// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"8af44d20","578":"afe04213"}[chunkId] + ".css";
};